/**
 * Environment utility functions for checking the current environment
 */

export const getEnvironmentInfo = () => {
    const { hostname } = window.location;

    return {
        isLocal: hostname === 'localhost' || hostname === '127.0.0.1',
        isDevelopment: hostname.includes('beacon-mmg-web-phase3'),
        isStaging: hostname.includes('mmg-staging-web'),
        isTestingEnv: hostname.includes('ac-aap-d-appl-mmg-web'),
        isProduction:
            hostname === 'beaconmmg.com' && !hostname.includes('staging')
    };
};

export const hasSAPTestingAccess = () => {
    const {
        isProduction,
        isStaging,
        isDevelopment,
        isLocal,
        isTestingEnv
    } = getEnvironmentInfo();
    return (
        !isProduction && (isStaging || isDevelopment || isLocal || isTestingEnv)
    );
};
